import {Component, EventEmitter, Input, Output} from '@angular/core';
import {FormsModule} from '@angular/forms';
import {NzFormControlComponent, NzFormDirective, NzFormItemComponent, NzFormLabelComponent} from 'ng-zorro-antd/form';
import {NzColDirective} from 'ng-zorro-antd/grid';
import {NzInputDirective} from 'ng-zorro-antd/input';
import {NzButtonComponent} from 'ng-zorro-antd/button';

@Component({
  selector: 'app-num-recibo',
  imports: [
    FormsModule,
    NzFormDirective,
    NzFormItemComponent,
    NzFormControlComponent,
    NzFormLabelComponent,
    NzColDirective,
    NzInputDirective,
    NzButtonComponent
  ],
  templateUrl: './num-recibo.component.html',
  styleUrl: './num-recibo.component.css'
})
export class NumReciboComponent {
  @Input() numRecibo: string = '';
  @Output() numReciboChange = new EventEmitter<string>();
  @Output() submit = new EventEmitter<void>();
  @Output() cancel = new EventEmitter<void>();

  submitReciboForm(): void {
    this.submit.emit();
    this.numRecibo='';
  }

  handleCancelReciboModal(): void {
    this.numRecibo='';
    this.cancel.emit();
  }
}
